define('lq/events/actions/forEach',['lq/events/actions/eventAction'], function (EventAction) {
    'use strict';

    var ForEach = function(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);

        this.eventName = eventData.forEach.eventName;
        this.eventArg = eventData.forEach.eventArg;
        this.dataSource = eventData.forEach.dataSource;
        
        return this;
    };

    EventAction.extend(ForEach, EventAction);

    ForEach.typeName = 'ForEach';

    ForEach.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ForEach.prototype.execute = function (continuation) {
        var self = this;

        if (self.shouldContinueWithoutDoingAnything()) {
            continuation();
        } else {
            self.piping.queryDispatcher.dispatch(
                self.dataSource.id,
                function (result) {
                    self.handleForEach(continuation, result.results, 0);
                });
        }
    };
    
    ForEach.prototype.shouldContinueWithoutDoingAnything = function () {
        return !this.piping.eventing.hasSubscribers(this.eventName);
    };

    ForEach.prototype.handleForEach = function (continuation, records, iterator) {
        var self = this;

        var nextRecord = function () {
            self.handleForEach(continuation, records, iterator + 1);
        };

        if (iterator + 1 > records.length) {
            continuation();
        } else {
            var arg = records[iterator][self.eventArg];
            self.piping.eventing.publish(self.eventName, self.eventSource, arg, nextRecord, self.getEventActionIdentifier());
        }
    };

    return ForEach;
});
